var _linearGradient, _polygon, _polygon2, _linearGradient2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "WLIJulVjW6wsxbwoEFfWIa",
    x1: 31.94,
    x2: 31.94,
    y1: 8.534,
    y2: 56.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#aab9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#WLIJulVjW6wsxbwoEFfWIa)",
    points: "49.42,11.71 46.2,48.53 31.9,52.45 17.78,48.44 14.46,11.71"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "19.153,17.377 44.404,17.377 42.176,42.734 31.885,46.129 21.699,43.158 21.063,35.838 25.837,35.838 26.474,39.657 31.991,41.142 37.614,39.445 38.038,32.867 20.851,32.973 20.426,27.774 38.569,27.774 38.887,22.363 19.684,22.257"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "WLIJulVjW6wsxbwoEFfWIb",
    x1: 31.939,
    x2: 31.939,
    y1: 3.214,
    y2: 58.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#WLIJulVjW6wsxbwoEFfWIb)",
    d: "M52.777,8.635 c-0.161-0.178-0.39-0.28-0.628-0.28H11.722c-0.238,0-0.458,0.102-0.62,0.28s-0.246,0.416-0.221,0.645l3.709,41.165 c0.034,0.357,0.28,0.645,0.62,0.747l16.441,4.668c0.076,0.017,0.153,0.025,0.238,0.025c0.068,0,0.144-0.008,0.221-0.025 l16.653-4.566c0.348-0.093,0.594-0.39,0.628-0.738L52.998,9.28C53.015,9.042,52.938,8.813,52.777,8.635z M31.04,53.916 l-14.811-4.201l-3.573-39.663H31.04v6.476H19.149c-0.238,0-0.467,0.102-0.628,0.28c-0.161,0.178-0.238,0.407-0.221,0.645 l0.475,4.982c0.042,0.441,0.407,0.772,0.849,0.772H31.04v3.718H20.134c-0.238,0-0.467,0.102-0.628,0.28 c-0.161,0.178-0.238,0.407-0.221,0.645l0.484,5.093c0.042,0.441,0.407,0.772,0.849,0.772H31.04v6.213l-3.887-1.137l-0.365-3.37 c-0.042-0.433-0.407-0.755-0.84-0.755h-5.076c-0.238,0-0.467,0.102-0.628,0.28c-0.161,0.178-0.238,0.407-0.221,0.645l0.721,7.639 c0.034,0.348,0.28,0.645,0.62,0.738l9.676,2.767V53.916z M32.738,33.716h4.481l-0.407,4.965l-4.074,1.188V33.716z M32.016,41.847 l0.721-0.212l5.11-1.485c0.339-0.102,0.577-0.399,0.611-0.747l0.526-6.468c0.017-0.238-0.068-0.467-0.221-0.645 c-0.161-0.17-0.39-0.272-0.628-0.272h-5.398H31.04h-9.65l-0.323-3.395h9.973h1.698h5.814c0.441,0,0.806-0.34,0.849-0.781 l0.441-5.415c0.017-0.238-0.068-0.467-0.221-0.645c-0.161-0.17-0.39-0.272-0.628-0.272h-6.255H31.04H20.397l-0.314-3.285H31.04 h1.698h10.941L41.387,42.5l-8.649,2.521l-0.747,0.221L31.04,44.97l-8.657-2.47l-0.577-6.137h3.378l0.348,3.174 c0.034,0.34,0.272,0.628,0.603,0.721l4.906,1.443l0.501,0.144C31.694,41.889,31.863,41.889,32.016,41.847z M32.738,23.208h5.339 l-0.306,3.718h-5.033V23.208z M47.744,49.817l-15.006,4.108v-7.13l9.676-2.826c0.331-0.093,0.577-0.39,0.611-0.738l2.436-25.777 c0.017-0.238-0.059-0.467-0.221-0.645c-0.161-0.178-0.39-0.28-0.628-0.28H32.738v-6.476h18.486L47.744,49.817z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.ac7e987349c505a627948079725c0149.svg";
export { ForwardRef as ReactComponent };